export { default } from './LightboxPhoto';
